<template>
	<!-- 사용 예시 : qms/FreeForm/Content/Table/TableSolutionTwo.vue -->
	<div class="qms-file-upload position-relative w-100 h-100">
		<div class="addScroll w-100 h-100 mr-5" :style="`width: ${width} !important; height: ${height} !important; `">
			<template v-if="setInit"> <input type="file" :accept="accept" :id="id" @change="onChange" multiple ref="fileInput" /></template>
			<div class="w-100 pr-4">
				<template v-for="(file, index) in fileNames">
					<template v-if="fileList[index].fileSeq">
						<div class="qms-file-upload__item mr-3" style="text-align: left" :key="index">
							<span class="file-upload__item__name" @click="() => onDownload(index)">{{ file }}</span>
							<i class="icon-sf-circle-close" @click="() => deleteFile(index)" v-show="isEditable" />
						</div>
					</template>
					<template v-else> </template>
				</template>
			</div>
		</div>
		<template v-if="isEditable">
			<label :for="id" class="unit input-icon"><i class="icon-sf-upload" /></label>
			<label class="unit input-icon" style="margin-top: 40px !important" @click="deleteAction">
				<i class="icon-sf-trash" />
			</label>
			<!-- <label for="upload" class="unit input-icon" style="margin-top: 40px !important"><i class="icon-sf-download" /></label> -->
		</template>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { checkFileSize } from '@/qmsUtils';

export default {
	name: 'file-upload-list',
	props: {
		id: { type: String, default: '' + (Math.random() * 10000 + 1) },
		propFileList: {
			type: Array,
			default() {
				return new Array();
			}
		},
		width: { type: String, default: '100px' },
		height: { type: String, default: '100px' },
		maxSize: { default: 200 * 1024 * 1024 },
		maxQuantity: { default: 10 },
		isEditable: { type: Boolean, default: true },
		accept: { type: String, default: '*' }
	},
	data() {
		return {
			setInit: true,
			fileList: [],
			quantity: 0,
			delFileList: [] // db 저장건 삭제할 목록
		};
	},
	created() {
		// console.log('download >>> ', this.propFileList, this.propFileList.length);
		this.fileList = this.propFileList || [];
		this.quantity = this.fileList.length;
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		fileNames() {
			return this.fileList?.map(file => {
				let flNm = file.origFileName || file.fileName || file.name || '';
				const name = flNm.substring(0, Math.min(flNm.lastIndexOf('.'), 25));
				const ext = flNm.substring(flNm.lastIndexOf('.') + 1);
				return name + '.' + ext;
			});
		}
	},
	watch: {
		fileList() {
			this.quantity = this.fileList.length;
			this.$emit('MultiFile', this.fileList, this.delFileList);
		},
		propFileList() {
			this.fileList = this.propFileList || [];
		}
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		onChange({ target: { files } }) {
			try {
				this.setInit = false;
				const fileArray = Array.from(files);
				let temp = [];
				let size = this.maxSize;
				let capacity = this.maxQuantity - this.quantity;
				if (fileArray.length <= 0) {
					throw new Error(this.getMessage_('QWCC001194'));
				}
				if (fileArray?.length > capacity) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC000064'), [this.maxQuantity + '']));
				}
				for (const file of fileArray) {
					if (!checkFileSize(file, this.maxSize)) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC000063'), ['200']));
					}
					if (size < file?.size) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC000063'), ['200']));
					}
					temp.push(file);
					size -= file.size;
				}
				this.fileList = this.fileList.concat(temp);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$refs.fileInput.value = '';
				this.setInit = true;
			}
		},
		deleteFile(index) {
			this.setInit = false;
			const isNotTemp = !!this.fileList[index].fileSeq;
			if (isNotTemp) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.deleteOne(index) }]
				});
			} else {
				this.fileList.splice(index, 1);
			}
			this.setInit = true;
		},
		deleteAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: this.deleteAllFiles }] //삭제
			});
		},
		async deleteOne(index) {
			try {
				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.deleteFile_({ fileId: this.fileList[index].fileId, fileSeq: this.fileList[index].fileSeq });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				this.fileList.splice(index, 1);
				this.delFileList.push(this.fileList[index]);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async deleteAllFiles() {
			try {
				this.setInit = false;
				this.$sf_toggleLoading(true);
				if (this.fileList.length) {
					const { code, messageCd } = await this.deleteFile_({ fileId: this.fileList[0].fileId, fileSeq: null });
					if (code === 0 || code === 3) {
						this.$sf_toast({
							type: code === 0 ? 'ok' : 'error',
							message: this.getMessage_(messageCd)
						});
					}
				} else {
					this.$sf_showMessage({ title: this.getMessage_('QWCC001147'), message: this.getMessage_('QWCC001147') });
					return;
				}
				this.delFileList = this.fileList.filter(file => !!file.fileSeq);
				this.fileList = [];
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
				this.setInit = true;
			}
		},
		onDownload(index) {
			if (this.fileList[index].fileSeq) {
				this.$emit('onDownload', this.fileList[index]);
			}
		},
		delInitFileList() {
			//파일리스트를 삭제할경우 필요함
			//부모뷰에서 이함수를 호출합니다.
			this.fileList = [];
		},
		reloadFileList(paramList) {
			//파일리스트를 다시 리로드할경우 파일리스트를 보내줘야됨
			//부모뷰에서 이함수를 호출합니다.
			this.fileList = paramList;
		}
	}
};
</script>
